module.exports = __webpack_public_path__ + "img/icon-lots-v2.77ff9197.svg";